import styled from 'styled-components'

const Cell = styled.div`
  display: flex;
  grid-column: ${p => p.column};
  grid-row: ${p => p.row};
`

export default Cell
